__turbopack_context__.v({
  "className": "dm_sans_72abc1c6-module__nLMN6W__className",
});
